module.exports = __webpack_public_path__ + "media/images/msec_5-d15b046048fb94c0f09b1c6b10d365f5.png";